import React from 'react'

import localwindow from 'browser-lib/window'
import { noop } from 'lodash'
import PropTypes from 'prop-types'
import qs from 'querystring'

import api from 'common/api'

import OAuthButton from '.'
import './OutlookOAuthButton.scss'
import outlookLogin from './sign-in-with-microsoft-light.png'

const OUTLOOK_AUTH_URL = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize'

class OutlookOAuthButton extends React.Component {
  signIn() {
    api.get('/api/oauth2/state?source=OutlookOAuth').then((result) => {
      const params = qs.stringify({
        response_type: 'code',
        client_id: localwindow.MICROSOFT_CLIENT_ID,
        state: result.State,
        redirect_uri: `https://${localwindow.location.host}/oauth/outlook/result`,
        scope: 'https://graph.microsoft.com/Calendars.ReadWrite offline_access',
      })
      this.props.onOAuthStart()
      localwindow.open(`${OUTLOOK_AUTH_URL}?${params}`, 'Login', 'width=400,height=500')
    })
  }
  render() {
    return (
      <div className="outlook-oauth-button-comp">
        <OAuthButton
          onSignIn={() => this.signIn()}
          isReady={true}
        >
          <img
            src={outlookLogin}
            alt="Sign in with Microsoft"
          />
        </OAuthButton>
      </div>
    )
  }
}

OutlookOAuthButton.defaultProps = {
  onOAuthStart: noop,
}

OutlookOAuthButton.propTypes = {
  onOAuthStart: PropTypes.func,
}

export default OutlookOAuthButton
